import styled from 'styled-components';
import { ellipsis } from 'polished';

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 40px 38px 40px 40px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.darkGrey};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 15px;
  }
`;
export const NoteWrapper = styled.div`
  display: flex;
`;
export const ReadMore = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  cursor: pointer;
  width: 100%;
`;
export const DescriptionText = styled.div<{ showMore?: boolean }>`
  font-size: 14px;
  margin-bottom: 20px;
  ${({ showMore }) => showMore && ellipsis(undefined, 3)}
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  column-gap: 50px;
`;
export const VerticalLine = styled.div`
  border-left: 2px solid ${({ theme }) => theme.palette.lightBlueGrey};
  height: 175px;
`;
export const TotalScoringWrapper = styled.div`
  border-radius: 8px;
  width: 242px;
  height: 196px;
  background-color: ${({ theme }) => theme.palette.NL20};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 73px;
    border-radius: 8px;
  }
`;
export const ScoringContainer = styled.div`
  display: flex;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: space-between;
    margin: 10px;
  }
`;
export const Center = styled.div`
  margin-top: 40px;
`;
export const Text = styled.div`
  color: ${({ theme }) => theme.palette.NL800};
  display: flex;
  justify-content: center;
  font-size: 14px;
`;
export const Scoring = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.palette.NL800};

  font-size: 24px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    text-align: center;
  }
`;
export const TooltipContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ReviewContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 8px;
`;
export const PercentContainer = styled.div`
  margin-left: auto;
`;
export const TooltipTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  display: flex;
  width: 150px;
  justify-content: space-between;
`;
export const ScoringLine = styled.div`
  margin: 4px;
  min-height: 5px;
  border-radius: 4px;
  flex-direction: row-reverse;
  vertical-align: middle;
`;
export const PercentWrapper = styled.div`
  max-width: 100px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
export const CommentIconContainer = styled.div`
  display: flex;
  gap: 6px;
`;

export const CommentContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Examination = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 8px;
  border-radius: 8px;
`;

export const SpeacialHotelWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;
export const ScoreContainer = styled.div`
  margin-left: -12px;
`;
export const CommentsWrapper = styled.div`
  margin-top: 20px;
  border: solid ${({ theme }) => theme.palette.lynxWhite} !important;
  border-radius: 8px;
  padding: 20px;
`;
